import router from '@/router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU.js'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import { MediaQueries } from 'vue-media-queries'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import App from './App.vue'
import store from './store'


const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

Vue.use(ElementUI, { locale });
Vue.use(store)
Vue.component('v-select', vSelect)

// Добавляем глобальный миксин для доступа к TelegramWebApp
Vue.mixin({
  data() {
    return {
      telegramWebAppGlobal: null,
    }
  },
  created() {
    // Проверяем доступность Telegram WebApp
    if (window.Telegram && window.Telegram.WebApp) {
      this.telegramWebAppGlobal = window.Telegram.WebApp;
      
      // Если мы в корневом компоненте, инициализируем WebApp
      if (this.$root === this) {
        console.log('Root component initializing Telegram WebApp');
        this.telegramWebAppGlobal.ready();
      }
    }
  }
})

new Vue({
    router,
    mediaQueries: mediaQueries,
    store,
    render: h => h(App)
}).$mount('#app')